<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="datas"
      resource="admin-users"
    >
      <!--<el-table-column
        prop="id"
        label="ID"
        align="center"
        show-overflow-tooltip
        min-width="2%"
      />-->
      <el-table-column
        prop="users"
        label="手机号"
        align="center"
        show-overflow-tooltip
        min-width="8%"
      >
      <template #default="{ row }">
          {{ row.users.mobile }}
        </template>
      </el-table-column>
      <el-table-column
        prop="type_name"
        label="获取途径"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      />
      <el-table-column
        prop="coupons_title"
        label="优惠券名"
        align="center"
        show-overflow-tooltip
        min-width="6%"
      >
        <template slot-scope="scope">
          {{ scope.row.coupons.title }}
        </template>
      </el-table-column>

      <el-table-column
        label="状态"
        align="center"
        show-overflow-tooltip
        min-width="4%"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status==1"
            type="success"
          >正常</el-tag>
          <el-tag
            v-else-if="scope.row.status==2"
            type="warning"
          >已使用</el-tag>
          <el-tag
            v-else
            type="danger"
          >失效</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="created_at"
        label="获取时间"
        align="center"
        show-overflow-tooltip
        min-width="5%"
      />
      <el-table-column
        label="操作"
        align="center"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row, $index }">
          <el-button-group>
            <el-button
              type="warning"
              @click="dialogVisibleClick(row)"
              size="small"
            >详情</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="20%"
    >
      <div class="info-wrp">
        <div class="title">优惠券详情</div>
        <div class="info-item">
          <span>优惠券名称:</span>
          <span>{{ rows.title }}</span>
        </div>
        <div class="info-item">
          <span>优惠券类型:</span>
          <span>{{ rows.type_name }}</span>
        </div>
        <div
          class="info-item"
          v-show="rows.type==1"
        >
          <span>满多少金额:</span>
          <span>{{ rows.with_amount }}</span>
        </div>
        <div class="info-item">
          <span>可减少金额:</span>
          <span>{{ rows.used_amount }}</span>
        </div>
        <!-- <div class="info-item">
          <span>是否限制发券量:</span>
          <span>{{ rows.quota_type_name }}</span>
        </div>
        <div class="info-item" v-show="rows.is_quota==1">
          <span>总可发券数量:</span>
          <span style="width:60%;">{{ rows.quota }}</span>
        </div>
        <div class="info-item">
          <span>已发券数量:</span>
          <span style="width:60%;">{{ rows.take_count }}</span>
        </div>
        <div class="info-item">
          <span>券已使用数量:</span>
          <span style="width:60%;">{{ rows.used_count }}</span>
        </div> -->
        <!-- <div class="info-item">
          <span>发放开始时间:</span>
          <span style="width:60%;">{{ rows.grant_start_at }}</span>
        </div>
        <div class="info-item">
          <span>发放结束时间:</span>
          <span style="width:60%;">{{ rows.grant_end_at }}</span>
        </div> -->
        <div class="info-item">
          <span>时效类型:</span>
          <span style="width:60%;">{{ rows.valid_type_name }}</span>
        </div>
        <div
          class="info-item"
          v-show="rows.valid_type==2"
        >
          <span>自领取起有效天数:</span>
          <span style="width:60%;">{{ rows.valid_days }}</span>
        </div>
        <div
          class="info-item"
          v-show="rows.valid_type==1"
        >
          <span>生效日期:</span>
          <span style="width:60%;">{{ rows.valid_start_time }}</span>
        </div>
        <div
          class="info-item"
          v-show="rows.valid_type==1"
        >
          <span>失效日期:</span>
          <span style="width:60%;">{{ rows.valid_end_time }}</span>
        </div>
      </div>
    </el-dialog>
    <!-- 弹框详情信息end -->
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getCouponUserBags } from "@/api/coupon";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "super-input",
          field: "mobile_nickname",
          label: "用户手机号"
        },
        {
          type: "el-select",
          field: "status",
          label: "状态",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "正常"
            },
            {
              id: 0,
              name: "失效"
            }
          ]
        }
      ],
      datas: [],
      page: null,
      first_blood: true,
      dialogVisible: false,
      rows: {}
    };
  },
  mixins: [mixinsAutoPageSize],
  async created() {
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[2].options.push.apply(
          this.search[2].options,
          merchant.data
        );
      }
    } 
  },

  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getCouponUserBags(newVal.query);
        this.datas = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  methods: {
    dialogVisibleClick(row) {
      this.rows = row.coupon_resource;
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
.info-wrp .title {
  font-size: 16px;
  // margin: 20px 0 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid #ccc;
}
.info-wrp .info-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 10px;
}
.info-wrp .info-item > span:first-child {
  display: inline-block;
  margin-right: 8px;
  width: 120px;
  text-align: right;
}
.info-wrp .pic-wrp > div:first-child {
  width: 120px;
  text-align: right;
}
.infodiv {
  line-height: 1.15;
  // border-top: 1px solid #ccc;
  padding-bottom: 10px;
  .title {
    border-top: 1px solid #ccc;
    font-size: 16px;
    margin: 10px;
    padding-top: 10px;
  }
  .info-item {
    margin-left: 30px;
    margin-bottom: 10px;
    :first-child {
      display: inline-block;
      width: 85px;
      text-align: right;
      font-size: 14px;
      margin-right: 8px;
    }
  }
}
</style>
